import { render, staticRenderFns } from "./Allergy.vue?vue&type=template&id=7764148e&"
import script from "./Allergy.vue?vue&type=script&lang=js&"
export * from "./Allergy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports